import React, { useMemo } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { resolveColor } from "utils/styles";

import Title from "./Title";
import MetaTitle from "./MetaTitle";
import ButtonGroup from "./ButtonGroup";
import Content from "./Content";
import renderItem from "utils/renderItem";

export default function Jumbotron(props) {
	const sectionIndex = props.sectionIndex;

	const fields = props.data?.fields;

	// Memoize the padding class to prevent unnecessary re-renders
	const paddingClass = useMemo(() => "jumbotron-padding", []);

	const marginTop = fields?.marginTop !== undefined ? fields?.marginTop : 0;
	const marginBottom = fields?.marginBottom !== undefined ? fields?.marginBottom : 1;

	return (
		<div className={`outerWrapper  JumbotronComponent`}>
			<Container fluid className={`g-0 ${paddingClass}`}>
				<div className="jumbotron extraPaddingBottom">
					<Row className="justify-content-center  g-0 ">
						<Col className="text-center" xs={12} md={10} lg={9}>
							{/* Render Components */}
							{fields?.components &&
								fields?.components.map((component) => {
									const model = component?.sys?.contentType?.sys.id;

									const key = component?.sys?.id;
									
									if (model === "metaTitle") {
										return <MetaTitle key={key} metaTitle={component} />;
									} else if (model === "media") {
										return (
											<Row key={key} className="g-0 justify-content-center ">
												<Col className="" xs={12} xl={8}>
													{renderItem(component, sectionIndex)}
												</Col>
											</Row>
										);
									} else if (model === "title") {
										return (
											<Row key={key} className="justify-content-center g-0">
												<Col
													xs={12}
													// md={11}
													xl={10}
													className="px-4 d-flex justify-content-center"
												>
													<div className="max-width-1200">
														<Title title={component} />
													</div>
												</Col>
											</Row>
										);
									} else if (model === "content") {
										return (
											<Row key={key} className=" justify-content-center g-0  ">
												<Col className="px-4 d-flex justify-content-center" xs={12} md={9}>
													<div className=" max-width-1200">
														{/* <Content content={component} /> */}
														{renderItem(component, sectionIndex)}
													</div>
												</Col>
											</Row>
										);
									} else {
										return (
											<Row key={key} className="g-0 justify-content-center px-4">
												<Col className="justify-content-center d-flex text-center ">
													{renderItem(component, sectionIndex)}
												</Col>
											</Row>
										);
									}
								})}
						</Col>
					</Row>
				</div>
			</Container>

			<style jsx="true">{`
				.outerWrapper {
					background: ${props.bgColor || resolveColor(fields?.backgroundColor) || "red"};
					padding-top: ${marginTop}em;
					padding-bottom: ${marginBottom}em;
				}
				
				:global(.jumbotron-padding) {
					padding-top: 1.5rem !important;
					padding-bottom: 1.5rem !important;
				}
				
				@media (min-width: 768px) {
					:global(.jumbotron-padding) {
						padding-top: 3rem !important;
						padding-bottom: 3rem !important;
					}
				}
			`}</style>
		</div>
	);
}
